module.exports = __webpack_public_path__ + "img/facebookLogo.8686fda8.svg";